import { useEffect, useState } from "react";
import { useLanguage } from "../../i18n/LanguageContext";
import api from "../../lib/api";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const Gallery = () => {
  const { lang } = useLanguage();
  const [photos, setPhotos] = useState(null);

  useEffect(() => {
    api.get("/photos", { params: { section: "gallery" } }).then(({ data }) => setPhotos(data)).catch(() => setPhotos([]));
  }, []);

  if (!photos || photos.length === 0) return null;

  return (
    <section data-testid="gallery-section" className="py-20 sm:py-28 px-4 sm:px-6 bg-[#080808]">
      <div className="max-w-7xl mx-auto">
        <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl text-white mb-3 tracking-tight">
          {lang === "nl" ? "Ons werk" : "Our work"}
        </h2>
        <p className="text-white/60 text-base mb-12 max-w-md">
          {lang === "nl" ? "Een impressie van kapsels en werkzaamheden bij EliteTheBarber." : "A glimpse of haircuts and craftsmanship at EliteTheBarber."}
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
          {photos.map((p) => (
            <div key={p.id} data-testid={`gallery-image-${p.id}`} className="aspect-[3/4] overflow-hidden rounded-xl border border-white/5 group">
              <img
                src={`${BACKEND_URL}${p.url}`}
                alt={(lang === "nl" ? p.alt_text_nl : p.alt_text_en) || "EliteTheBarber"}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
